module.exports = __webpack_public_path__ + "static/StairlinShip8bitcopy-b60abf2ed9d1b53094a7fa71aba277d6.png";